import React from 'react';
import './Info.css';
import homelogo from './images/career-plant-logo.png';

const Info = (props) => {
  return (
    <section>
      <img src={homelogo} alt='< >'></img>
      <h1>{props.title}</h1>
      <br />
      <h2>{props.subtitle}</h2>
    </section>
  );
};

export default Info;
